export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  text?: string;
  centered?: boolean;
}

export function LoadingSpinner({ size = 'md', className, text, centered = false }: LoadingSpinnerProps) {
  const getSizeClass = () => {
    switch (size) {
      case 'sm':
        return 'spinner-border-sm';
      case 'lg':
        return 'spinner-border-lg';
      default:
        return '';
    }
  };

  const spinnerClassName = `spinner-border ${getSizeClass()} ${className || ''}`;
  const containerClassName = `d-flex align-items-center justify-content-center${centered ? ' py-5' : ''}`;

  return (
    <div className={containerClassName}>
      <div className={spinnerClassName} role="status">
        <span className="visually-hidden">Ładowanie...</span>
      </div>
      {text && <span className="ms-2">{text}</span>}
    </div>
  );
}
